import moment from 'moment';
import { dropStatusDocumento } from 'utils/drops';

const getNotasFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number', defaultValue: '' },
  {
    name: 'status',
    label: 'Status',
    type: 'select',
    options: dropStatusDocumento,
    multiple: true,
    defaultValue: ['PENDENTE'],
  },
  {
    name: 'situacao',
    label: 'Situação',
    type: 'select',
    options: drops?.StatusDocumento,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'natureza_operacao',
    label: 'Natureza da Operação',
    type: 'select',
    options: drops?.NaturezaOperacao,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'dtemissao.i',
    column: 'dtemissao',
    label: 'Data de Emissão Inicial',
    type: 'date',
    defaultValue: moment().subtract(1, 'months').format('YYYY-MM-DD'),
  },
  {
    name: 'dtemissao.f',
    column: 'dtemissao',
    label: 'Data de Emissão Final',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'dtentrada.i',
    column: 'dtentrada',
    label: 'Data de Entrada Inicial',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'dtentrada.f',
    column: 'dtentrada',
    label: 'Data de Entrada Final',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'documento',
    label: 'Nº do Documento',
    type: 'number',
    defaultValue: '',
    initial: true,
  },
  {
    name: 'entidade',
    label: 'Entidade',
    type: 'virtual-select',
    options: drops?.Entidade,
    multiple: true,
    defaultValue: [],
  },
  { name: 'vldocto', label: 'Valor', type: 'currency', defaultValue: '' },
  {
    name: 'filial',
    label: 'Filial',
    type: 'select',
    options: drops?.Filial,
    multiple: true,
    defaultValue: [],
  },
  { name: 'whatsapp', label: 'Contato', defaultValue: '' },
];

export default getNotasFilterFields;
